export default __webpack_public_path__ + "static/media/distribucion-variedades-medleys.cd39dbf9.png";